import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCheckComponent } from "./med-icon-check.component";

@NgModule({
  declarations: [
    MedIconCheckComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCheckComponent,
  ],
})
export class MedIconCheckModule { }
